import React from 'react'
import LeagueSearchSelectorDropdown from './leagueSearchSelectorDropdown'

const LeagueSearchSelector = (props) => {
  return (
      <LeagueSearchSelectorDropdown prevNextList={props.prevNextList} activeTab={props.activeTab}/>
  )
}

export default LeagueSearchSelector